import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {EquityOrder} from "../../place-equity-order-wizard/models/EquityOrder";
import {EquityOrderType, EquityWizardData} from "../../place-equity-order-wizard/models/EquityWizardData";
import {PlaceEquityWizard} from "../../place-equity-order-wizard/PlaceEquityOrderWizard";
import {OrderLifetime, OrderSide} from "../../../../../orders/models/OrderRecord";
import {AsxInstrumentUtil} from "../../../../../js/util/asx/AsxInstrumentUtil";
import {AccountId} from "../../../../../account/types/AccountRecord";
import {PricingInstruction} from "../../../../../orders/models/PricingInstruction";
import {PriceStrategyService} from "../../../../../components/inputs/price/service/PriceStrategyService";
import {PriceStrategy} from "../../../../../components/inputs/price/input/PriceStrategy";
import {Exchange} from "../../../../../instruments/exchange/Exchange";
import {OrderViewModel} from "../../../../../orders/models/OrderViewModel";
import {PlaceChildWizard} from "../../place-child-order-wizard/PlaceChildOrderWizard";
import {AccountBriefRecord} from "../../../../../account/types/AccountBriefRecord";

export class EquityTicketDialogService {

    public static readonly id = "equityTicketDialogService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService,
                       private readonly priceStrategyService: PriceStrategyService) {

    }

    public async open(orderPrototype: Partial<EquityOrder>, accountId?: AccountId): Promise<EquityWizardData> {
        const order = this.initOrder(orderPrototype);
        const modalConfig: IModalSettings = {
            component: PlaceEquityWizard,
            backdrop: "static",
            size: "lg",
            resolve: {
                order: () => order,
                accountId: () => accountId
            }
        };
        const instance = this.$uibModal.open(modalConfig);
        return instance.result;
    }

    public async openChildOrderWizard(order: OrderViewModel, account: AccountBriefRecord): Promise<EquityWizardData> {
        const orderModel: EquityWizardData = {
            orderNumber: order.orderNumber,
            code: order.code,
            exchange: order.exchange,
            portfolio: account,
            strategy: order.priceStrategy,
            quantity: order.uncommittedVolume,
            side: order.side,
            limit: order.limit ?? undefined,
            lifetime: order.lifetime,
            pricingInstruction: order.pricingInstruction,
            type: EquityOrderType.QUANTITY,
            totalValue: 0,
            isStopLoss: false, // find a way to assign stop loss
            isParentOrder: true,
            childOrders: []
        };

        const modalConfig: IModalSettings = {
            component: PlaceChildWizard,
            backdrop: "static",
            size: "lg",
            resolve: {
                order: () => orderModel
            }
        };
        const instance = this.$uibModal.open(modalConfig);
        return instance.result;
    }

    private initOrder(orderPrototype: Partial<EquityOrder>): EquityWizardData {
        const code = orderPrototype.code;
        let exchange = orderPrototype.exchange;
        if ((exchange == null) && (code != null)) {
            exchange = AsxInstrumentUtil.guessExchange(code);
        }

        let strategy: PriceStrategy | undefined;
        if (code != null) {
            strategy = this.priceStrategyService.forCode(code);
        }

        let lifetime: OrderLifetime | undefined = OrderLifetime.GOOD_TILL_CANCEL;
        if (exchange === Exchange.AXW || exchange === Exchange.CXA) {
            lifetime = OrderLifetime.END_OF_DAY;
        }

        const quantity = orderPrototype.quantity ?? 0;
        const side = orderPrototype.side ?? OrderSide.BUY;
        const type = EquityOrderType.QUANTITY;
        const limit = orderPrototype.limit;

        return {
            code,
            exchange,
            strategy,
            quantity: Math.abs(quantity),
            side,
            limit,
            lifetime,
            pricingInstruction: PricingInstruction.LIMIT,
            type,
            totalValue: 0,
            isStopLoss: false,
            isParentOrder: false,
            childOrders: []
        };
    }
}
